import React from "react";
import "./AppBackground.scss";

const AppBackground = () => {
  return <div className="app-background" />;
};

export default AppBackground;
